import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'subscriber_UPDATE',
    smsDelete : 'subscriber_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        subscriber: [],
        contact: [],

        submitSuccess: false,
        subscriberLoading: false,
        subscriberError: false,
        contactLoading: false,
        contactError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SUBSCRIBER(state, subscriber) {
            state.subscriber = subscriber;
        },

        SET_CONTACT(state, contact) {
            state.contact = contact;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBSCRIBER_LOADING (state, loading) {
            state.subscriberLoading = loading;
        },

        SUBSCRIBER_ERROR (state, hasError) {
            state.subscriberError = hasError;
        },

        CONTACT_LOADING (state, loading) {
            state.contactLoading = loading;
        },

        CONTACT_ERROR (state, hasError) {
            state.contactError = hasError;
        }
    },

    actions: {
        // Subscriber
        async fetchSubscriber ({ commit }) {
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_subscriber, config);
                let response = result.data.data
                commit('SET_SUBSCRIBER', response);
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async deleteSubscriber({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_subscriber + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchSubscriber')
            return response
        },

        // Contact
        async fetchContact ({ commit }) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.contact_list, config);
                let response = result.data.data
                commit('SET_CONTACT', response);
                return result
            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async deleteContact({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_contact + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchContact')
            return response
        }
    },

    getters: {}
}
